// extracted by mini-css-extract-plugin
module.exports = {"decoratorTitle":"decorator-title_decoratorTitle__1F9hc"};